<script setup>
import { useVModel } from "@vueuse/core";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  defaultValue: { type: [String, Number], default: undefined },
  modelValue: { type: [String, Number], default: undefined },
});

const emit = defineEmits(["update:modelValue"]);

const modelValue = useVModel(props, "modelValue", emit, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <textarea
    v-model="modelValue"
    data-slot="textarea"
    :data-filled="modelValue !== '' && modelValue != null ? '' : undefined"
    :class="
      cn(
        'text-foreground border-input placeholder:text-muted-foreground placeholder:text-xs focus-visible:border-primary  aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-border/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        props.class
      )
    "
  />
</template>
